import { render } from "./PosTicket.vue?vue&type=template&id=cb6882f2&scoped=true"
import script from "./PosTicket.vue?vue&type=script&lang=js"
export * from "./PosTicket.vue?vue&type=script&lang=js"

import "./PosTicket.vue?vue&type=style&index=0&id=cb6882f2&scoped=true&lang=css"
import "./PosTicket.vue?vue&type=style&index=1&id=cb6882f2&lang=css"

import exportComponent from "/home/dyam/Documentos/RAREZA/mi-stock-rareza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb6882f2"]])

export default __exports__